import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import fondoLibertad from "../assets/img/fondoLibertad.webp";
import expoUno from "../assets/img/expUno.webp";
import test from "../assets/img/test.webp";
import calendario from "../assets/img/ingresoAlumno.webp";
import ingAlum from "../assets/img/ingresoAlumno.webp";
import ingDoc from "../assets/img/ingresoDocente.webp";
import { useParams, useNavigate } from "react-router-dom";
import dataJson from "../assets/json/datos.json"; // JSON con info de cada sede
import "./Inscripcion.css";
import tituloHero from "../assets/img/tituloHero.png";
export default function Inscripcion() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 0)
        setIsScrolled(true); // Ajusta el scroll para fijar
      else setIsScrolled(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { sede } = useParams();
  const [chicaImg, setChicaImg] = useState(null);
  const [fondoImg, setFondoImg] = useState(fondoLibertad); // <-- nuevo estado

  useEffect(() => {
    if (!sede) return;

    const dataSede = dataJson[sede];

    // Imagen chica
    if (dataSede?.imagenes?.personaPortada) {
      try {
        const img = require(
          `../assets/img/${dataSede.imagenes.personaPortada}`,
        );
        setChicaImg(img);
      } catch {
        setChicaImg(require("../assets/img/ChicaUno.webp"));
      }
    } else {
      setChicaImg(require("../assets/img/ChicaUno.webp"));
    }

    // Imagen de fondo dinámica según subsede
    if (dataSede?.imagenes?.fondoIncripcion) {
      try {
        const fondo = require(
          `../assets/img/${dataSede.imagenes.fondoIncripcion}`,
        );
        setFondoImg(fondo);
      } catch {
        setFondoImg(fondoLibertad);
      }
    } else {
      setFondoImg(fondoLibertad);
    }
  }, [sede]);
  const esYacuiba = sede?.toLowerCase() === "yacuiba";

  const botones = [
    { img: ingDoc, text: "Ingreso Docente", link: `/${sede}/docente` },
    { img: ingAlum, text: "Ingreso Alumno", link: `/${sede}/estudiante` },
    {
      img: calendario,
      text: "Calendario Académico",
      link: "https://drive.google.com/file/d/1C44VlWgvp5plZ8xPZyTZKBa37wwkaXpm/view?usp=sharing",
    },
    ...(esYacuiba
      ? [
          {
            img: test,
            text: "Test UNO",
            link: "https://www.test-uno.com/welcome",
          },
        ]
      : []),
    // Si en Yacuiba solo van los 4 botones principales, excluimos este ícono vacío:
    ...(!esYacuiba ? [{ img: expoUno, text: "", link: "" }] : []),
  ];

  return (
    <section
      className={`hero-inscripcion ${sede === "shinahota" ? "shinahota" : ""}`}
      style={{
        background: `linear-gradient(to right, rgba(0, 33, 90, 0.9), rgba(11, 67, 163, 0.9)), url(${fondoImg}) center/cover no-repeat`,
      }}
    >
      <div className="container-hero">
        <div className="hero-content">
          <motion.img
            src={chicaImg || require("../assets/img/ChicaUno.webp")}
            alt="Chica invitando"
            className="chica"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          />

          <motion.div
            className="hero-text"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <img
              src={tituloHero}
              alt="Bienvenidos a la Universidad UNO Gestión II - 2026"
              className="hero-titulo-img"
            />
          </motion.div>
        </div>
      </div>
      <motion.div
        className={`sub-menu ${esYacuiba ? "sub-menu-grid-2x2" : ""}`}
        animate={
          window.innerWidth > 768
            ? {
                scale: isScrolled ? 0.7 : 1,
                bottom: isScrolled ? 0 : 0,
                right: isScrolled ? 0 : 0,
                position: isScrolled ? "fixed" : "absolute",
                x: isScrolled ? 99 : 0,
                y: isScrolled ? 15 : 0,
              }
            : {}
        }
        whileHover={
          window.innerWidth > 768
            ? isScrolled
              ? {
                  scale: 1,
                  x: 0,
                  y: -2,
                  transition: { type: "spring", stiffness: 1800, damping: 100 },
                }
              : undefined
            : undefined
        }
        transition={{ type: "spring", stiffness: 200, damping: 25 }}
      >
        {botones.map((item, i) => (
          <motion.div
            key={i}
            className="sub-menu-item"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (!item.link) return;

              if (item.link.startsWith("/")) {
                navigate(item.link); // ruta interna React
              } else {
                window.open(item.link, "_blank"); // enlace externo
              }
            }}
          >
            <motion.img
              src={item.img}
              alt={item.text}
              className="sub-menu-img"
              // 🔥 PEQUEÑA ANIMACIÓN SIEMPRE ACTIVA
              whileHover={{ rotate: 10, scale: 1.05 }}
            />

            {item.text && (
              <motion.span
                className="sub-menu-text"
                // 🔥 Animación suave SIEMPRE
                whileHover={{ scale: 1.05 }}
              >
                {item.text}
              </motion.span>
            )}
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
